export function noPassByMobile (str) {
  if (str != null && str !== undefined && str !== '') {
    var pat = /(\d{3})\d*(\d{4})/
    return str.replace(pat, '$1****$2')
  } else {
    return ''
  }
}

export function noPassByName (str) {
  if (str != null && str !== undefined && str !== '') {
    if (str.length <= 3) {
      return '*' + str.substring(1, str.length)
    } else if (str.length > 3 && str.length <= 6) {
      return '**' + str.substring(2, str.length)
    } else if (str.length > 6) {
      return str.substring(0, 2) + '****' + str.substring(6, str.length)
    }
  } else {
    return ''
  }
}

export function noPassByCardId (str) {
  if (str != null && str !== undefined && str !== '') {
    str = str.toString()
    return str.replace(/^(.{4})(?:\d+)(.{4})$/, '$1 **** **** $2')
  } else {
    return ''
  }
}

export function noPassByOrganizeData (str) {
  if (str != null && str !== undefined && str !== '') {
    return str.substring(0, 1) + '****************' + str.substring(str.length - 1, str.length)
  } else {
    return ''
  }
}
